import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';
import { renderGoogleIdentityButton } from '../../services/oauthProviders';

const GoogleIdentityButton = ({
  onCredential,
  disabled = false,
  className = '',
  text = 'continue_with',
  theme = 'outline',
  size = 'large',
  shape = 'pill',
  width = 360,
  fallbackLabel = 'Google sign-in unavailable',
  enableOneTap = false,
}) => {
  const containerRef = useRef(null);
  const oneTapPromptedRef = useRef(false);
  const hasGoogleConfig = Boolean(config.oauth.googleClientId)
    || (typeof window !== 'undefined' && Boolean(window.__STUDIOAEYE_TEST_GOOGLE_CLIENT_ID || window.google?.accounts?.id));
  const [loading, setLoading] = useState(hasGoogleConfig);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enableOneTap) {
      oneTapPromptedRef.current = false;
    }

    if (disabled || !hasGoogleConfig || !containerRef.current) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    const shouldPromptOneTap = enableOneTap && !oneTapPromptedRef.current;
    setLoading(true);
    setError('');

    renderGoogleIdentityButton(containerRef.current, {
      onCredential: (response) => {
        if (cancelled) {
          return;
        }

        setError('');
        onCredential?.(response);
      },
      text,
      theme,
      size,
      shape,
      width,
      enableOneTap: shouldPromptOneTap,
    })
      .then(() => {
        if (!cancelled) {
          if (shouldPromptOneTap) {
            oneTapPromptedRef.current = true;
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setLoading(false);
          setError(err.message || 'Google sign-in is unavailable right now.');
        }
      });

    return () => {
      cancelled = true;
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [disabled, enableOneTap, hasGoogleConfig, onCredential, shape, size, text, theme, width]);

  if (!hasGoogleConfig) {
    return (
      <button type="button" className={`auth-button secondary ${className}`.trim()} disabled>
        {fallbackLabel}
      </button>
    );
  }

  return (
    <div className={`google-identity-slot ${className}`.trim()}>
      <div ref={containerRef} className="google-identity-slot__button" aria-busy={loading} />
      {loading ? <p className="auth-provider-note">Loading Google sign-in…</p> : null}
      {error ? (
        <div className="error-message" role="alert">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default GoogleIdentityButton;
